import { notification } from 'antd';
import moment from 'moment';
import { Fragment, PureComponent, ReactNode } from 'react';
import Hotkeys from 'react-hot-keys';
import { connect, useSelector } from 'react-redux';
import { ShepherdTour } from 'react-shepherd';
import createLabTestCart, { LabOption } from '../../../../api/createLabTestCart';
import { OrderDetails } from '../../../../api/fetchAllHEOrder';
import { LabTest } from '../../../../api/fetchMatchingDrugsLabTests';
import fetchPatientAddress, { Add } from '../../../../api/fetchPatientAddress';
import { PatientFormData } from '../../../../api/fetchPatientDirByDocOid';
import getLabTestsOrder, { Data, EditOrderConfig } from '../../../../api/getLabTestsOrder';
import orderLabTestCart, {
    AdditionalMember,
    Request as RequestPayload,
    UpdateStatuses,
} from '../../../../api/orderLabTestCart';
import { GenieSettings } from '../../../../api/pushGenie';
import CancelOrderOrBooking from '../../../../pages/CancelOrderOrBooking';
import { captureError, captureErrorString } from '../../../../pages/captureError';
import {
    Button,
    FinishedPageFooter,
    stepsForFinishState,
} from '../../../../pages/trialOrder/Utils';
import { checkIfValidPhoneNumber, fetchAllVisits, openCrispChat } from '../../../../pages/utils';
import { pushGenieToBE } from '../../../../store/appReduxMiddleware';
import {
    getItemFromMisc,
    getMySingleDoctorId,
    getPrintConfig,
    getSelectedClinicId,
    MISC_KEYS,
    updateItemInMisc,
} from '../../../../store/idbHandler';
import { GlobalState } from '../../../../store/reducers';
import { getGenieSetting } from '../../../../store/selectors/session';
import {
    LabTestsEntityOrProceduresEntity,
    Prescription,
} from '../../../../store/types/prescription';
import { track } from '../../../../tracking';
import { SlideFromRightWrapper } from '../../../common/SlideFromRightWrapper';
import { Address } from './AddAddressModal';
import AddAddressModalCC from './AddAddressModalCC';
import AddRecipientModal from './AddRecipientModal';
import {
    AddressFormInput,
    createCartErrorObj,
    ERR_NON_SERVICEABLE,
    FetchingLoader,
    getSteps,
    getTimeIn12HourFormat,
    HomeCollectionFees,
    getVendorLogo,
    LabTestsIncludedInPackage,
    OrderDetailsComponent,
    PreferredLabPartner,
    SelectedSlotDetails,
    showDateInText,
    UnavailableLabTests,
    inClinicSampleCollectionEnabled,
    sampleCollectionTypes,
    INCLINIC_COLLECTION,
    getClinicAddress,
    TestingType,
    AdditionalMembers,
    AllVendorsContainer,
    getPrescription,
    HOME_COLLECTION,
    InfoText,
    LabOrderEditUpdates,
} from './BookLabTestsUtils';
import EditLabTestModal from './EditLabTestModal';
import ExitTrialWarningModal from './ExitTrialWarningModal';
import { DeliveryAddressMapSVG, paymodeObject, RecipientDetails } from './OrderMedicineUtils';
import SelectPaymodeModal from './SelectPaymodeModal';
import SelectSlotModal from './SelectSlotModal';
import { Patient, Personal } from '../../../../store/types/patient';
import { AddPtModal } from '../../../common/newaddpt/NewPatientModal';
import capitalize from 'lodash/capitalize';
import PrescribeAutoSuggestV2 from '../workspace/PrescribeAutoSuggestV2';
import { pushVisitWithSanitizePrescription } from './FinishedPanel';
import { Translate } from '../../../../api/pushVisit';
import setHEOnboardingProfile from '../../../../api/setHEOnboardingProfile';
import { ACTIVE_TAB } from '../../../../pages/HEDashboard';
import { getMyDbId } from '../../../../api/mactiveid';

const ORANGE_HEALTH_VENDOR_ID = 'v_002';

type Props = {
    closeMe: () => void;
    formData: PatientFormData[];
    patientid: string;
    name: string;
    phone: string;
    gender: string;
    pxid: string;
    age: number;
    orderId?: string;
    isForTrialOrder?: boolean;
    changeSteps?: (activeStep?: number) => void;
    hxngPreferredLabPartnerId: string[];
    showGoToHEDashboardButton?: boolean;
    isForQuickCart?: boolean;
    patient?: Patient;
    hideBackButton?: boolean;
    isForEditOrder?: boolean;
};

type State = {
    isFetchingOrder?: boolean;
    finishedState?: Data[];
    currentOrderIndex: number;
    isFetchingAddress?: boolean;
    patientAddressArray: Add[];
    addressFormInput: AddressFormInput;
    isFetchingCart?: boolean;
    labOptions: LabOption[];
    selectedOption: number;
    showSelectSlotModal?: boolean;
    selectedSlotDetails?: SelectedSlotDetails;
    isBookLabTestLoading?: boolean;
    recipientDetails: RecipientDetails;
    paymode: string;
    showAddRecipient?: boolean;
    showSelectPaymode?: boolean;
    showAddAddress?: boolean;
    isEditingAddress?: boolean;
    showOptions?: boolean;
    discount: string;
    discountInp: string;
    showEditLabTest?: boolean;
    prescriptionLabTests: LabTestsEntityOrProceduresEntity[];
    selectedLabTests: Set<string>;
    showExitTrialWarningModal?: boolean;
    preferredLabPartnerId: string[];
    activeOrder?: OrderDetails;
    paymodes?: string[];
    collectionType: string;
    inClinicSampleCollection?: boolean;
    showAddAdditionalMemberModal?: boolean;
    additionalMembers: AdditionalMemberWithPersonal[];
    isFetchingLastRx?: boolean;
    lastRxLabTests?: LabTestsEntityOrProceduresEntity[];
    orderArray?: Data[];
    showLabOrderEditUpdates: boolean;
    updateStatuses?: UpdateStatuses;
};

export interface AdditionalMemberWithPersonal extends AdditionalMember {
    personal: Personal;
}

const convertToArray = (id: string | string[]): string[] => (typeof id === 'string' ? [id] : id);

export const ADDRESS_FORM_INPUT = {
    line: '',
    landmark: '',
    city: '',
    state: '',
    city_id: '',
    place_id: '',
    coordinates: '',
    pincode: '',
};

class BookLabTests extends PureComponent<Props, State> {
    initialState: State = {
        isFetchingOrder: undefined,
        finishedState: undefined,
        currentOrderIndex: 0,
        isFetchingAddress: undefined,
        patientAddressArray: [],
        addressFormInput: ADDRESS_FORM_INPUT,
        isFetchingCart: undefined,
        labOptions: [],
        selectedOption: 0,
        showSelectSlotModal: undefined,
        selectedSlotDetails: undefined,
        isBookLabTestLoading: undefined,
        paymode: '',
        recipientDetails: {
            name: this.props.name,
            mobile: this.props.phone,
            alternative_mobile:
                (this.props.formData.find((i) => i.key === 'aphone')?.value as string)?.slice(
                    -10,
                ) || '',
        },
        showAddRecipient: undefined,
        showSelectPaymode: undefined,
        showAddAddress: undefined,
        isEditingAddress: undefined,
        showOptions: undefined,
        discount: '',
        discountInp: '',
        showEditLabTest: undefined,
        prescriptionLabTests: [],
        selectedLabTests: new Set(),
        showExitTrialWarningModal: undefined,
        preferredLabPartnerId: convertToArray(this.props.hxngPreferredLabPartnerId),
        activeOrder: undefined,
        paymodes: undefined,
        collectionType: INCLINIC_COLLECTION,
        inClinicSampleCollection: undefined,
        showAddAdditionalMemberModal: undefined,
        additionalMembers: [],
        isFetchingLastRx: undefined,
        lastRxLabTests: undefined,
        orderArray: undefined,
        showLabOrderEditUpdates: true,
        updateStatuses: undefined,
    };

    state: State = this.initialState;

    start = new Date().getTime();
    createCartErrorCode: string | undefined;

    componentDidMount = (): void => {
        const { pxid, orderId, isForQuickCart, isForEditOrder } = this.props;

        if (isForQuickCart) {
            this.fetchPtAddress(isForQuickCart);
            this.fetchFromLastRx();
        } else {
            this.setState({ isFetchingOrder: true });
            const pxId = !orderId ? pxid : '';
            getLabTestsOrder(pxId, orderId)
                .then((i) => {
                    if (i.success) {
                        if (isForEditOrder) {
                            const newState = {
                                orderArray: i.data,
                            };
                            this.setState(newState, this.setEditableOrder);
                        } else {
                            this.setState({
                                finishedState: i.data,
                                isFetchingOrder: false,
                            });
                        }
                    } else {
                        this.setState({ isFetchingOrder: false });
                        this.fetchPtAddress();
                    }
                })
                .catch(() => {
                    this.setState({ isFetchingOrder: false });
                    this.fetchPtAddress();
                });
        }
    };

    setEditableOrder = () => {
        const { orderArray, currentOrderIndex } = this.state;
        if (!orderArray || !orderArray.length) return;
        const {
            address,
            collection_date,
            collection_slot,
            cart,
            platformdiscount,
            paymode,
            inclinic_sample_collection,
        } = orderArray[currentOrderIndex];
        const {
            id,
            details: { start_time, end_time },
        } = collection_slot;
        const newState = {
            isFetchingOrder: false,
            addressFormInput: address,
            selectedSlotDetails: {
                collection_date: collection_date,
                collection_slot: {
                    id: id,
                    details: {
                        start_time: start_time,
                        end_time: end_time,
                    },
                },
            },
            prescriptionLabTests: cart,
            discount: String(platformdiscount),
            discountInp: String(platformdiscount),
            paymode: paymode,
            inClinicSampleCollection: inclinic_sample_collection,
            collectionType: inclinic_sample_collection ? INCLINIC_COLLECTION : HOME_COLLECTION,
        };
        const callback = () => this.createLabTestCart(address, cart);
        this.setState(newState, callback);
    };

    fetchPtAddress = (isForQuickCart?: boolean): void => {
        const { patientid } = this.props;

        this.setState({
            isFetchingAddress: true,
        });

        const docId = getMySingleDoctorId() || '';

        fetchPatientAddress(docId, patientid)
            .then((i) => {
                const addressArray = i.address.filter((i) => i.address.coordinates?.trim());

                if (addressArray[0]?.address) {
                    const { address } = addressArray[0];
                    const addressFormInput = {
                        ...address,
                        _id: addressArray[0]._id,
                        line: address.line1,
                        landmark: address.line2,
                    };
                    if (!isForQuickCart) this.createLabTestCart(addressFormInput);
                    this.setState({
                        addressFormInput: addressFormInput,
                    });
                } else {
                    if (!isForQuickCart) this.createLabTestCart();
                }

                this.setState({
                    patientAddressArray: addressArray,
                    isFetchingAddress: false,
                });
            })
            .catch(() => {
                if (!isForQuickCart) this.createLabTestCart();
                this.setState({
                    isFetchingAddress: false,
                });
            });
    };

    fetchFromLastRx = async () => {
        try {
            const { patientid } = this.props;
            this.setState({ isFetchingLastRx: true });
            const response = await fetchAllVisits(patientid, 1);
            if (response?.state === 'success' && response?.data) {
                const lastVisit = response.data?.sort((date1, date2) => {
                    return date1 > date2 ? -1 : 1;
                })[0];
                if (lastVisit && lastVisit.labTests && lastVisit.labTests.length > 0) {
                    const lastRxLabTests = lastVisit.labTests;
                    this.setState({ lastRxLabTests });
                }
            }
        } catch (error) {
            captureError(error as Error);
            track('ERROR', {
                on: 'fetchFromLastRx [Lab Tests]',
                error: (error as Error).message,
            });
        } finally {
            this.setState({ isFetchingLastRx: false });
        }
    };

    calculateExtraCharges = (i: LabOption): number => {
        const { collectionType } = this.state;
        const isInclinicCollection = collectionType === INCLINIC_COLLECTION;
        if (isInclinicCollection && inClinicSampleCollectionEnabled.has(i?.vendor_id)) return 0;
        const extraChargesArray = Object.entries(i?.extra_charges || {});
        const totalExtraCharges = extraChargesArray.reduce((acc, cur) => {
            return acc + cur[1];
        }, 0);
        return totalExtraCharges;
    };

    createLabTestCart = (
        address?: AddressFormInput,
        eka_lab?: LabTestsEntityOrProceduresEntity[],
    ): void => {
        if (Array.isArray(eka_lab) && eka_lab.length === 0) {
            notification.error({
                message: `Please select lab investigation to add to cart`,
                duration: 5,
            });
            this.setState({
                labOptions: [],
                selectedSlotDetails: undefined,
                selectedOption: -1,
            });
            return;
        }

        const {
            pxid,
            patientid,
            isForTrialOrder,
            hxngPreferredLabPartnerId,
            isForQuickCart,
            isForEditOrder,
        } = this.props;
        const {
            selectedOption,
            selectedSlotDetails,
            paymode,
            discount,
            labOptions: previousLabOptions,
            collectionType,
            additionalMembers,
            orderArray,
            currentOrderIndex,
        } = this.state;

        const docId = getMySingleDoctorId() || '';

        this.setState({
            isFetchingCart: true,
        });
        const noOfMembers = additionalMembers.length + 1;
        const { vendorid = '' } =
            orderArray && orderArray.length > 0 ? orderArray[currentOrderIndex] : {};
        createLabTestCart(docId, {
            [eka_lab ? 'eka_lab' : 'pxid']: eka_lab || pxid,
            docid: docId,
            patientid,
            address,
            discount: 0,
            no_of_members: noOfMembers,
            vendor_id: vendorid || '',
        })
            .then((i) => {
                if (i.success) {
                    const selectedLabTests = new Set(i.labData.map((i) => i.id));
                    const labOptions = i.data;
                    const preferredOptions: LabOption[] = [];
                    const restOptions: LabOption[] = [];
                    labOptions.forEach((i) => {
                        if (convertToArray(hxngPreferredLabPartnerId).includes(i.vendor_id)) {
                            preferredOptions.push(i);
                        } else {
                            restOptions.push(i);
                        }
                    });
                    const finalLabOptions = preferredOptions.concat(restOptions);
                    const currentOptionIndex = finalLabOptions.findIndex(
                        (i) => i.vendor_id === previousLabOptions[selectedOption]?.vendor_id,
                    );
                    const currentPaymode = isForTrialOrder
                        ? 'FREE'
                        : i.paymodes && i.paymodes.length === 1
                        ? i.paymodes[0]
                        : paymode;
                    const inClinicSampleCollection = !isForEditOrder
                        ? i.in_clinic_sample_collection
                        : false;
                    const newCollectionType = !isForEditOrder
                        ? i.in_clinic_sample_collection
                            ? collectionType
                            : ''
                        : '';
                    const newSelectedOption = currentOptionIndex !== -1 ? currentOptionIndex : 0;
                    const vendorId = finalLabOptions[newSelectedOption].vendor_id;
                    const isInclinicCollectionSelected =
                        newCollectionType === INCLINIC_COLLECTION &&
                        inClinicSampleCollectionEnabled.has(vendorId);

                    this.setState({
                        labOptions: finalLabOptions,
                        selectedLabTests,
                        discount: '',
                        discountInp: discount,
                        paymode: isInclinicCollectionSelected ? '' : currentPaymode,
                        selectedOption: newSelectedOption,
                        selectedSlotDetails:
                            currentOptionIndex !== -1 ? selectedSlotDetails : undefined,
                        paymodes: i.paymodes,
                        inClinicSampleCollection: inClinicSampleCollection,
                        collectionType: newCollectionType,
                    });
                    if (!eka_lab) {
                        this.setState({
                            prescriptionLabTests: i.labData,
                        });
                    }
                    setTimeout(() => {
                        const startTourButton = document.getElementById('start-tour');
                        startTourButton && startTourButton.click();
                    }, 1000);
                    track('CREATE_LAB_TEST_CART_SUCCESS');
                    this.createCartErrorCode = undefined;
                } else {
                    const error_code = i.error || '';
                    notification.error({
                        message: createCartErrorObj[error_code] || error_code || 'No SKU Available',
                        duration: 5,
                    });
                    track('ERROR', { on: 'createLabTestCart', what: i.error });
                    this.createCartErrorCode = error_code;
                }
            })
            .catch((e) => {
                notification.error({
                    message: 'Fetch Lab Tests => ' + e,
                    duration: 5,
                });
                track('ERROR', { on: 'createLabTestCart', what: (e as Error).message });
            })
            .finally(() => {
                const newState = {
                    isFetchingCart: false,
                    selectedSlotDetails: this.createCartErrorCode ? undefined : selectedSlotDetails,
                };
                this.setState(newState, this.applyDiscount);
                if (isForQuickCart && this.createCartErrorCode) {
                    this.setState({
                        labOptions: [],
                        selectedOption: -1,
                    });
                }
            });
    };

    selectSlotHandler = (slot: SelectedSlotDetails): void => {
        this.setState({
            selectedSlotDetails: slot,
            showSelectSlotModal: false,
        });
    };

    bookLabTestHandler = async (): Promise<void> => {
        const {
            patientid,
            pxid,
            gender,
            age,
            formData,
            isForTrialOrder,
            patient,
            isForQuickCart,
            isForEditOrder,
        } = this.props;
        const {
            addressFormInput,
            selectedSlotDetails,
            labOptions,
            selectedOption,
            recipientDetails,
            paymode,
            discount,
            collectionType,
            additionalMembers,
            prescriptionLabTests,
            orderArray,
            currentOrderIndex,
        } = this.state;
        const docId = getMySingleDoctorId() || '';
        const { pincode } = addressFormInput;
        const { vendor_id, max_members_allowed = 1, isForSmartPackages } = labOptions[
            selectedOption
        ];
        if (additionalMembers.length > max_members_allowed - 1) {
            notification.error({
                message: `Number of members must be between 0 to ${max_members_allowed}`,
                duration: 5,
            });
            return;
        }
        const isInclinicCollectionSelected =
            collectionType === INCLINIC_COLLECTION &&
            inClinicSampleCollectionEnabled.has(vendor_id);

        if (pincode.length !== 6 && !isInclinicCollectionSelected) {
            notification.error({
                message: 'Enter valid pincode',
                duration: 5,
            });
            return;
        }

        if (!this.isValidAddress() && !isInclinicCollectionSelected) {
            notification.error({
                message: 'Enter valid address',
                duration: 5,
            });
            return;
        }

        if (!paymode) return this.setState({ showSelectPaymode: true });

        if (!selectedSlotDetails && !isInclinicCollectionSelected) {
            return this.showSelectSlotModalHandler();
        }

        const numberError = this.getNumberError(recipientDetails);
        if (numberError && !isInclinicCollectionSelected) {
            this.showAddRecipientModalHandler();
            notification.error({
                message: `Enter valid ${numberError} number`,
                duration: 5,
            });
            return;
        }

        this.setState({
            isBookLabTestLoading: true,
        });

        const { vendor, mrp, sku, extra_charges, fare_dict } = labOptions[selectedOption];
        const collectionDate = moment().format('YYYY-MM-DD');
        const collectionSlot = {
            id: 1,
            details: {
                start_time: '00:00:00',
                end_time: '00:00:00',
            },
        };
        const clinicAddress = getClinicAddress();
        const { name, mobile } = recipientDetails;
        const primaryMember = {
            patient_id: patientid,
            name: name || '',
            mobile: mobile || '',
        };
        const additionalMembersArray = additionalMembers.map(({ patient_id, name, mobile }) => ({
            patient_id,
            name,
            mobile,
        }));
        additionalMembersArray.unshift(primaryMember);
        const requestPayload: RequestPayload = {
            patientid,
            pxid,
            collection_date: collectionDate,
            collection_slot: collectionSlot,
            address: addressFormInput,
            customerDetails: {
                ...recipientDetails,
                age,
                gender: gender === 'other' ? 'others' : gender.toLowerCase(),
                customer_email: formData?.find((i) => i.key === 'email')?.value as string,
            },
            paymode: isForTrialOrder ? 'EKA' : paymode,
            vendor,
            vendor_id,
            discount: Number(discount),
            booking_price: mrp,
            pincode: isInclinicCollectionSelected ? clinicAddress.pincode : pincode,
            cart: sku,
            extra_charges: !isInclinicCollectionSelected ? extra_charges : {},
            placedByDoctor: isForTrialOrder,
            fare_dict,
            members: additionalMembersArray,
        };

        if (isForEditOrder) {
            requestPayload.order_id = orderArray?.[currentOrderIndex].order_id;
        }

        if (selectedSlotDetails) {
            const { collection_date, collection_slot } = selectedSlotDetails;
            requestPayload.collection_date = collection_date;
            requestPayload.collection_slot = {
                id: collection_slot.id,
                details: collection_slot.details,
            };
        }

        if (isInclinicCollectionSelected) {
            requestPayload.address = clinicAddress;
            requestPayload.sample_collection_type = collectionType;
        }
        if (isForQuickCart) {
            const pc = await getPrintConfig(getMyDbId() || '');
            const t = await getItemFromMisc<Translate>(getMyDbId() || '', MISC_KEYS.translate);

            const prescription = getPrescription(
                patient as Patient,
                prescriptionLabTests,
            ) as Prescription;
            try {
                const response = await pushVisitWithSanitizePrescription(
                    prescription,
                    new Date(),
                    new Date(),
                    'send',
                    pc,
                    t,
                    undefined,
                    undefined,
                    false,
                );
                if (response.status !== 'success') {
                    notification.error({
                        message: 'Failed to save presciption',
                        duration: 5,
                    });
                    captureErrorString('Failed to save presciption [Lab Tests]');
                    track('ERROR', {
                        on: 'pushVisitWithSanitizePrescription',
                        what: 'Failed to save presciption [Lab Tests]',
                    });
                    this.setState({
                        isBookLabTestLoading: false,
                    });
                    return;
                }
            } catch (err) {
                notification.error({
                    message: 'Failed to save presciption => ' + err,
                    duration: 5,
                });
                captureError(err as Error);
                track('ERROR', {
                    on: 'pushVisitWithSanitizePrescription',
                    error: (err as Error).message,
                });
                this.setState({
                    isBookLabTestLoading: false,
                });
                return;
            }
            requestPayload.pxid = prescription.id;
        }

        if (isForTrialOrder) {
            try {
                await setHEOnboardingProfile({ isTrialOrderPlaced: true });
            } catch (err) {
                captureError(err as Error);
                track('ERROR', {
                    on: 'setHEOnboardingProfile [Mark lab trial order]',
                    error: (err as Error).message,
                });
            }
        }

        orderLabTestCart(docId, requestPayload)
            .then((i) => {
                const { changeSteps, isForTrialOrder } = this.props;
                const { handleCloseTour } = this;

                if (i.success) {
                    track('BOOK_LAB_TEST_CART_SUCCESS', {
                        timeToPlaceOrder: `${(new Date().getTime() - this.start) / 1000} seconds`,
                        isForTrialOrder: String(Boolean(isForTrialOrder)),
                        member: String(additionalMembers.length + 1),
                        isPackage: String(!!isForSmartPackages),
                        vendorId: vendor_id,
                        isForQuickCart: String(Boolean(isForQuickCart)),
                        isForEditOrder: String(Boolean(isForEditOrder)),
                    });
                    changeSteps && changeSteps();
                    handleCloseTour();
                    this.setState({
                        finishedState: i.order,
                        updateStatuses: i.update_statuses,
                    });
                } else {
                    notification.error({
                        message: i.error,
                        duration: 5,
                    });
                    track('ERROR', { on: 'bookLabTestCart', what: i.error });
                }
            })
            .catch((e) => {
                notification.error({
                    message: 'Place Order => ' + e,
                    duration: 5,
                });
                track('ERROR', { on: 'bookLabTestCart', what: (e as Error).message });
            })
            .finally(() => {
                this.setState({
                    isBookLabTestLoading: false,
                });
            });

        this.setPreferredLabPartnerId();
    };

    setRecipientHandler = (recipientDetails: RecipientDetails): void => {
        this.setState({
            recipientDetails,
            showAddRecipient: false,
        });
    };

    paymodeHandler = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        const { pxid } = this.props;
        const { value } = e.target;
        this.setState({
            paymode: value,
        });
        track('BOOK_LAB_TEST_PAYMODE_CHANGE', {
            pxId: pxid,
            paymode: value,
        });
    };

    collectionTypeHandler = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        const { pxid } = this.props;
        const { labOptions, selectedOption, paymode } = this.state;
        const { value } = e.target;
        const vendroId = labOptions[selectedOption].vendor_id;
        const isInclinicCollectionSelected =
            value === INCLINIC_COLLECTION && inClinicSampleCollectionEnabled.has(vendroId);
        this.setState({
            collectionType: value,
            selectedSlotDetails: undefined,
            paymode: isInclinicCollectionSelected ? '' : paymode,
        });
        track('BOOK_LAB_TEST_SAMPLE_COLLECTION_TYPE_CHANGE', {
            pxId: pxid,
            collectionType: value,
        });
    };

    isValidAddress = (): boolean => {
        const { addressFormInput } = this.state;
        const { line, landmark, city, state, pincode } = addressFormInput;

        return (
            line.trim().length >= 1 &&
            landmark.trim().length >= 3 &&
            city.trim().length >= 3 &&
            state.trim().length >= 3 &&
            pincode.trim().length === 6
        );
    };

    setAddressHandler = (add: Address): void => {
        const { _id, line, address, city, state, latLng, placeID, pincode } = add;
        const { labOptions, prescriptionLabTests, selectedLabTests } = this.state;
        const addressFormInput = {
            _id,
            line,
            landmark: address,
            city: city,
            state: state,
            coordinates: latLng,
            place_id: placeID,
            city_id: '',
            pincode,
        };
        this.setState({
            addressFormInput,
            showAddAddress: false,
            isEditingAddress: false,
            showOptions: false,
        });
        if (labOptions.length === 0) {
            this.createLabTestCart(addressFormInput);
        } else {
            const currentLabTests = prescriptionLabTests.filter((i) => selectedLabTests.has(i.id));
            this.createLabTestCart(addressFormInput, currentLabTests);
        }
        this.handleCloseTour(true);
    };

    applyDiscount = (): void => {
        const { labOptions, discountInp, selectedOption } = this.state;
        const selectedLabOption = labOptions[selectedOption];
        const inClinicMaxDiscount = selectedLabOption?.max_discount;
        const MAX_DISCOUNT = Number(inClinicMaxDiscount) || 0;
        if (Number(discountInp) < 0 || Number(discountInp) > MAX_DISCOUNT) {
            notification.error({
                message: `Discount must be between 0 to ${MAX_DISCOUNT}`,
                duration: 5,
            });
            return;
        }
        if (selectedLabOption) {
            selectedLabOption.finalprice = (1 - Number(discountInp) / 100) * selectedLabOption.mrp;
        }
        this.setState({
            discount: discountInp,
            labOptions,
        });
    };

    editLabTestModalHandler = (): void => {
        this.setState({
            showEditLabTest: true,
        });
        track('EDIT_LAB_TEST');
    };

    editLabTestsHandler = (selectedLabTests: LabTestsEntityOrProceduresEntity[]): void => {
        const { addressFormInput } = this.state;
        const { isValidAddress } = this;
        this.setState({
            showEditLabTest: false,
            selectedLabTests: new Set(selectedLabTests.map((i) => i.id)),
        });
        this.createLabTestCart(isValidAddress() ? addressFormInput : undefined, selectedLabTests);
    };

    showSelectSlotModalHandler = (): void => {
        this.setState({
            showSelectSlotModal: true,
        });
        track('BOOK_LAB_TEST_SLOT_SELECT');
    };

    showAddRecipientModalHandler = (): void => {
        const { pxid } = this.props;
        this.setState({
            showAddRecipient: true,
        });
        track('BOOK_LAB_TEST_RECIPIENT_DETAILS_CHANGED', {
            pxId: pxid,
        });
    };

    handleCloseTour = (reset?: boolean): void => {
        const { changeSteps } = this.props;
        const shepherdTourDivs = document.getElementsByClassName(
            'shepherd-tour',
        ) as HTMLCollectionOf<HTMLElement>;
        Array.from(shepherdTourDivs).forEach((ele) => ele && ele.remove());
        if (reset) changeSteps && changeSteps(0);
        else changeSteps && changeSteps();
    };

    exitTrialToggleHandler = (): void => {
        const { showExitTrialWarningModal } = this.state;
        this.setState({
            showExitTrialWarningModal: !showExitTrialWarningModal,
        });
        track('EXIT_TRIAL_BUTTON_CLICK', {
            action: showExitTrialWarningModal ? 'close' : 'open',
        });
    };

    preferredLabPartnerIdHandler = (id: string) => {
        let { preferredLabPartnerId } = this.state;
        if (preferredLabPartnerId.includes(id)) {
            preferredLabPartnerId = preferredLabPartnerId.filter((i) => i !== id);
        } else {
            preferredLabPartnerId = [...preferredLabPartnerId, id];
        }
        this.setState({
            preferredLabPartnerId,
        });
    };

    setPreferredLabPartnerId = async (): Promise<void> => {
        const { hxngPreferredLabPartnerId } = this.props;
        const { preferredLabPartnerId } = this.state;

        const hxngPreferredLabPartnerIdString = convertToArray(hxngPreferredLabPartnerId)
            .sort()
            .join('');
        const preferredLabPartnerIdString = preferredLabPartnerId.sort().join('');

        if (hxngPreferredLabPartnerIdString === preferredLabPartnerIdString) return;

        try {
            const settings = await getItemFromMisc<GenieSettings>(
                getMyDbId() || '',
                MISC_KEYS.settings,
            );
            await updateItemInMisc(getMyDbId() || '', MISC_KEYS.settings, {
                ...settings,
                hxngPreferredLabPartnerId: preferredLabPartnerId,
            });
            await pushGenieToBE(getMyDbId() || '', ['settings']);
            track('HXNG_PREFERRED_LAB_PARTNER_ID', {
                value: JSON.stringify(preferredLabPartnerId),
            });
        } catch (error) {
            captureError(error as Error);
            track('ERROR', {
                on: 'setPreferredLabPartnerId',
                error: (error as Error).message,
            });
        }
    };

    toggleActiveOrder = (order?: OrderDetails) => {
        if (order?.status === 'cancelled') {
            notification.error({
                message: 'Error: Booking already cancelled!',
                duration: 5,
                placement: 'topRight',
            });
            return;
        }
        this.setState({
            activeOrder: order,
        });
        if (order) {
            track('CANCEL_ORDER_OR_BOOKING', {
                from: 'trial order',
                activeTab: ACTIVE_TAB.LABS,
                order_id: order?.id,
            });
        }
    };

    editAddressHandler = () => {
        this.setState({
            showAddAddress: true,
            isEditingAddress: true,
        });
        track('BOOK_LAB_TEST_ADDRESS_EDIT');
    };

    onOptionClick = (i: LabOption, index: number) => {
        const { labOptions, selectedOption, collectionType, paymode } = this.state;
        if (selectedOption === index) return;
        const selectedLabOption = labOptions[selectedOption];
        selectedLabOption.finalprice = selectedLabOption.mrp;
        const isVendorChange = selectedLabOption.vendor !== i.vendor;
        const isInclinicCollectionSelected =
            collectionType === INCLINIC_COLLECTION &&
            inClinicSampleCollectionEnabled.has(i.vendor_id);
        this.setState({
            selectedOption: index,
            discount: '',
            labOptions,
            paymode: isInclinicCollectionSelected ? '' : paymode,
        });
        if (isVendorChange) {
            this.setState({
                selectedSlotDetails: undefined,
            });
        }
        track('BOOK_LAB_TEST_OPTION_CHANGE');
    };

    callback = () => {
        const { addressFormInput, selectedLabTests, prescriptionLabTests } = this.state;
        const { isValidAddress } = this;
        const currentLabTests = prescriptionLabTests.filter((i) => selectedLabTests.has(i.id));
        this.createLabTestCart(isValidAddress() ? addressFormInput : undefined, currentLabTests);
    };

    toggleAddAdditionalMember = () => {
        const { showAddAdditionalMemberModal } = this.state;
        this.setState({
            showAddAdditionalMemberModal: !showAddAdditionalMemberModal,
        });
        track('TOGGLE_ADD_ADDITIONAL_MEMBER', {
            action: showAddAdditionalMemberModal ? 'CLOSE' : 'OPEN',
        });
    };

    onAddAdditionalMember = (patient: Patient) => {
        const { patientid } = this.props;
        const { additionalMembers } = this.state;
        const { callback } = this;
        const { id, localId, personal } = patient;
        const patientId = id || localId;
        const {
            name: { f, l },
            phone,
        } = personal;
        const newMember = {
            patient_id: patientId,
            name: [f, l].filter(Boolean).join(' '),
            mobile: phone?.n || '',
            personal,
        };
        if (additionalMembers.find((i) => i.patient_id === patientId) || patientid === patientId) {
            notification.error({
                message: 'Error: Patient already added',
                duration: 5,
            });
            return;
        }
        additionalMembers.push(newMember);
        const newState = {
            additionalMembers,
        };
        this.setState(newState, callback);
    };

    deleteAdditionalMember = (id: string) => {
        const { additionalMembers } = this.state;
        const { callback } = this;
        const newAdditionalMembers = additionalMembers.filter((i) => i.patient_id !== id);
        const newState = {
            additionalMembers: newAdditionalMembers,
        };
        this.setState(newState, callback);
    };

    onNeedHelp = () => {
        const { pxid } = this.props;
        const { finishedState, currentOrderIndex } = this.state;
        if (finishedState && finishedState.length) {
            const { id, status, sub_status } = finishedState[currentOrderIndex] as OrderDetails;
            openCrispChat(
                'NEED_HELP_HXNG',
                {
                    from: 'Order Dashboard',
                    type: 'lab',
                    order_id: id,
                    status,
                    sub_status: sub_status,
                },
                `I have an issue with this Lab order  - ${id} - Status : ${capitalize(status)} ${
                    sub_status ? `(${capitalize(sub_status)})` : ''
                }`,
            );
        } else {
            openCrispChat(
                'NEED_HELP_HXNG',
                {
                    from: 'Cart',
                    type: 'lab',
                    px_id: pxid,
                },
                `I have an issue with creating this Lab order - for Rx : ${pxid}`,
            );
        }
    };

    onAutoSuggestLabTestSelect = (labTest: LabTestsEntityOrProceduresEntity) => {
        const { prescriptionLabTests, addressFormInput } = this.state;
        const { isValidAddress } = this;
        const newPrescriptionLabTests = prescriptionLabTests;
        newPrescriptionLabTests.push(labTest);
        this.setState({ prescriptionLabTests: newPrescriptionLabTests });
        this.createLabTestCart(
            isValidAddress() ? addressFormInput : undefined,
            newPrescriptionLabTests,
        );
        track('AUTO_SUGGEST_LAB_TEST_SELECT');
    };

    onAddFromLastRx = async () => {
        const { lastRxLabTests, addressFormInput } = this.state;
        const { isValidAddress } = this;
        if (!lastRxLabTests || !lastRxLabTests.length) return;
        this.setState({ prescriptionLabTests: lastRxLabTests });
        this.createLabTestCart(isValidAddress() ? addressFormInput : undefined, lastRxLabTests);
        track('ADD_FROM_LAST_RX');
    };

    removeLabTestHandler = (id: string) => {
        const { prescriptionLabTests, addressFormInput } = this.state;
        const { isValidAddress } = this;
        const newPrescriptionLabTests = prescriptionLabTests.filter((i) => i.id !== id);
        this.setState({ prescriptionLabTests: newPrescriptionLabTests });
        this.createLabTestCart(
            isValidAddress() ? addressFormInput : undefined,
            newPrescriptionLabTests,
        );
        track('REMOVE_LAB_TEST');
    };

    onRefresh = () => {
        const { finishedState, currentOrderIndex } = this.state;
        this.setState({
            activeOrder: undefined,
        });
        if (Array.isArray(finishedState)) {
            finishedState[currentOrderIndex].status = 'cancelled';
            finishedState[currentOrderIndex].sub_status = 'cancelled';
            this.setState({
                finishedState: Array.from(finishedState),
            });
        }
    };

    getNumberError = (recipientDetails: RecipientDetails): string => {
        return !checkIfValidPhoneNumber('+91', recipientDetails.mobile)
            ? 'mobile'
            : recipientDetails.alternative_mobile.length > 0 &&
              !checkIfValidPhoneNumber('+91', recipientDetails.alternative_mobile)
            ? 'alternative mobile'
            : '';
    };

    hideExtraCharges = (i: LabOption) => {
        const { collectionType } = this.state;
        const isInclinicCollection = collectionType === INCLINIC_COLLECTION;
        if (isInclinicCollection && inClinicSampleCollectionEnabled.has(i.vendor_id)) return true;
        return false;
    };

    closeLabOrderEditUpdates = () => {
        this.setState({ showLabOrderEditUpdates: false });
    };

    onTryAgain = () => {
        const { initialState, closeLabOrderEditUpdates, componentDidMount, setState } = this;
        closeLabOrderEditUpdates();
        setState(initialState, componentDidMount);
    };

    render(): ReactNode {
        const {
            closeMe,
            name,
            gender,
            age,
            patientid,
            isForTrialOrder,
            changeSteps,
            showGoToHEDashboardButton,
            isForQuickCart,
            hideBackButton,
            isForEditOrder,
        } = this.props;
        const {
            isFetchingOrder,
            finishedState,
            isFetchingAddress,
            isFetchingCart,
            labOptions,
            selectedOption,
            showSelectSlotModal,
            addressFormInput,
            recipientDetails,
            showAddRecipient,
            showSelectPaymode,
            paymode,
            isBookLabTestLoading,
            patientAddressArray,
            showAddAddress,
            showOptions,
            isEditingAddress,
            discount,
            discountInp,
            selectedSlotDetails,
            showEditLabTest,
            prescriptionLabTests,
            selectedLabTests,
            currentOrderIndex,
            showExitTrialWarningModal,
            preferredLabPartnerId,
            activeOrder,
            paymodes,
            inClinicSampleCollection,
            collectionType,
            showAddAdditionalMemberModal,
            additionalMembers,
            isFetchingLastRx,
            lastRxLabTests,
            orderArray,
            showLabOrderEditUpdates,
            updateStatuses,
        } = this.state;
        const {
            selectSlotHandler,
            bookLabTestHandler,
            setRecipientHandler,
            paymodeHandler,
            isValidAddress,
            setAddressHandler,
            applyDiscount,
            editLabTestModalHandler,
            editLabTestsHandler,
            showSelectSlotModalHandler,
            showAddRecipientModalHandler,
            createCartErrorCode,
            calculateExtraCharges,
            exitTrialToggleHandler,
            preferredLabPartnerIdHandler,
            toggleActiveOrder,
            editAddressHandler,
            collectionTypeHandler,
            onOptionClick,
            toggleAddAdditionalMember,
            onAddAdditionalMember,
            deleteAdditionalMember,
            onNeedHelp,
            onAutoSuggestLabTestSelect,
            onAddFromLastRx,
            removeLabTestHandler,
            onRefresh,
            getNumberError,
            hideExtraCharges,
            closeLabOrderEditUpdates,
            onTryAgain,
        } = this;

        const vendor = labOptions[selectedOption]?.vendor;
        const vendor_id = labOptions[selectedOption]?.vendor_id;
        const finalprice =
            labOptions[selectedOption]?.finalprice +
            calculateExtraCharges(labOptions[selectedOption]);
        const { name: recipientName, mobile, alternative_mobile } = recipientDetails;
        const numberError = getNumberError(recipientDetails);
        const { line, landmark, city, state, pincode } = addressFormInput;

        const slotDetails: { [k: string]: string } = {};
        if (selectedSlotDetails) {
            const { collection_date, collection_slot } = selectedSlotDetails;
            const {
                details: { start_time, end_time },
            } = collection_slot;
            slotDetails['date'] = collection_date;
            slotDetails['start_time'] = getTimeIn12HourFormat(start_time);
            slotDetails['end_time'] = getTimeIn12HourFormat(end_time);
        }

        let paymodeArray = Object.entries(paymodeObject);

        if (paymodes?.length) {
            const availablePaymodes = new Set(paymodes);
            paymodeArray = paymodeArray.filter((i) => availablePaymodes.has(i[0]));
        }

        if (isForTrialOrder) {
            paymodeArray = [['FREE', 'Free']];
        }

        const isInclinicCollection =
            inClinicSampleCollection && inClinicSampleCollectionEnabled.has(vendor_id);

        const isInclinicCollectionSelected =
            collectionType === INCLINIC_COLLECTION &&
            inClinicSampleCollectionEnabled.has(vendor_id);

        const inClinicMaxDiscount = labOptions[selectedOption]?.max_discount;
        const MAX_DISCOUNT = Number(inClinicMaxDiscount) || 0;
        const ptGender = gender.toUpperCase()[0];

        const showSearchInput = isForQuickCart || isForEditOrder;
        const editOrderConfig =
            orderArray && orderArray.length > 0
                ? orderArray[currentOrderIndex].edit_order_config
                : {};
        const {
            canUpdateSlot = true,
            canUpdateTest = true,
            canUpdatePaymode = true,
            canUpdateDiscount = true,
            canUpdateAddress = true,
            canUpdatePatientDetails = true,
        } = (editOrderConfig || {}) as EditOrderConfig;

        const discountedPrice =
            labOptions[selectedOption]?.mrp * (1 - Number(discount || 0) * 0.01);

        const docId = getMySingleDoctorId() || '';

        return (
            <Fragment>
                <div
                    className={`flex flex-col relative h-full w-full font-400 ${
                        !hideBackButton ? 'bg-darwin-neutral-50' : ''
                    }`}
                >
                    <div className="px-16 py-9 flex items-center justify-between bg-white pad-shadow-v2">
                        <div className="flex items-center space-x-12 cursor-pointer">
                            {!isForTrialOrder && !hideBackButton && (
                                <div
                                    onClick={closeMe}
                                    className="flex items-center justify-center w-16 h-16"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 448 512"
                                        className="w-16 h-16 fill-darwin-neutral-1000"
                                    >
                                        <path d="M447.1 256c0 13.25-10.76 24.01-24.01 24.01H83.9l132.7 126.6c9.625 9.156 9.969 24.41 .8125 33.94c-9.156 9.594-24.34 9.938-33.94 .8125l-176-168C2.695 268.9 .0078 262.6 .0078 256S2.695 243.2 7.445 238.6l176-168C193 61.51 208.2 61.85 217.4 71.45c9.156 9.5 8.812 24.75-.8125 33.94l-132.7 126.6h340.1C437.2 232 447.1 242.8 447.1 256z"></path>
                                    </svg>
                                </div>
                            )}
                            <p className="text-darwin-neutral-1000 heading-2 bold">
                                {hideBackButton
                                    ? 'Lab Tests Booked'
                                    : isForEditOrder
                                    ? 'Edit Lab Order'
                                    : 'Book Lab Tests'}
                            </p>

                            <p className="text-darwin-neutral-800 font-700 text-13 font-700">
                                <span className="font-400">for</span> {name}{' '}
                                {age ? ` | ${age}y` : ''}
                                {ptGender ? ` | ${ptGender}` : ''}
                            </p>
                        </div>

                        <div className="flex items-center space-x-10">
                            <button
                                className="border border-darwin-primary-500 flex items-center space-x-10 rounded-4 px-12 py-4 font-700"
                                onClick={onNeedHelp}
                            >
                                <p>
                                    <svg
                                        className="min-w-16 h-18 fill-darwin-primary-500"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                    >
                                        <path d="M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm169.8 53.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" />
                                    </svg>
                                </p>
                                <p className="text-darwin-primary-500">
                                    {finishedState && finishedState.length
                                        ? 'Issue with Order?'
                                        : 'Need Help?'}
                                </p>
                            </button>

                            {isForTrialOrder && (
                                <div
                                    className="flex items-center cursor-pointer"
                                    onClick={exitTrialToggleHandler}
                                >
                                    <svg
                                        className="w-14 h-14 fill-darwin-neutral-1000"
                                        viewBox="0 0 12 12"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M10.75 9.71875C11.0312 10.0312 11.0312 10.5 10.75 10.7812C10.4375 11.0938 9.96875 11.0938 9.6875 10.7812L6 7.0625L2.28125 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 1.96875 0.90625 1.5 1.21875 1.21875C1.5 0.90625 1.96875 0.90625 2.25 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.75 1.25C11.0625 1.53125 11.0625 2 10.75 2.3125L7.03125 6L10.75 9.71875Z" />
                                    </svg>
                                </div>
                            )}
                        </div>

                        {finishedState && finishedState.length > 1 && (
                            <div className="absolute w-full flex items-center justify-center">
                                {finishedState.map((i, index) => {
                                    return (
                                        <p
                                            onClick={() => {
                                                this.setState({ currentOrderIndex: index });
                                            }}
                                            className={`border-b-2 px-14 py-6 ${
                                                currentOrderIndex === index
                                                    ? 'text-darwin-primary-500 font-700 border-darwin-primary-500'
                                                    : 'border-white'
                                            }`}
                                        >
                                            Lab Order {index + 1}
                                        </p>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    {isFetchingOrder ? (
                        <FetchingLoader text="Order" />
                    ) : finishedState && finishedState.length ? (
                        <Fragment>
                            <OrderDetailsComponent
                                finishedState={finishedState[currentOrderIndex]}
                                isForTrialOrder={isForTrialOrder}
                            />
                            {isForTrialOrder && (
                                <Fragment>
                                    <FinishedPageFooter
                                        type="lab"
                                        orderDetails={
                                            finishedState[currentOrderIndex] as OrderDetails
                                        }
                                        toggleActiveOrder={toggleActiveOrder}
                                        isForTrialOrder
                                    />
                                    <ShepherdTour
                                        steps={stepsForFinishState('lab')}
                                        tourOptions={{
                                            exitOnEsc: true,
                                        }}
                                    >
                                        <Button />
                                    </ShepherdTour>
                                </Fragment>
                            )}
                            {showGoToHEDashboardButton && (
                                <FinishedPageFooter
                                    type="lab"
                                    orderDetails={finishedState[currentOrderIndex] as OrderDetails}
                                    toggleActiveOrder={toggleActiveOrder}
                                />
                            )}
                        </Fragment>
                    ) : isFetchingAddress ? (
                        <FetchingLoader text="Address" />
                    ) : isFetchingCart ? (
                        <FetchingLoader text="Cart" />
                    ) : (
                        <Fragment>
                            <div
                                className={`flex-1 flex flex-col space-y-12 px-16 pt-16 pb-4 overflow-hidden`}
                            >
                                {showSearchInput && canUpdateTest && (
                                    <PrescribeAutoSuggestV2
                                        kind={'Lab Tests'}
                                        onSelect={onAutoSuggestLabTestSelect}
                                        hideCustomEntity
                                        className="bg-white"
                                        prescriptionElements={prescriptionLabTests}
                                        isForHXNGFlow={showSearchInput}
                                    />
                                )}

                                <div className="flex-1 overflow-hidden relative grid grid-cols-5 gap-x-12">
                                    {!showSearchInput && labOptions.length === 0 ? (
                                        <div className="col-span-5 h-90p flex flex-col bg-white rounded-8 pb-16">
                                            <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                                                <div className="flex items-center space-x-8">
                                                    <div className="flex items-center justify-center w-24 h-24 rounded-4 bg-darwin-accent-medical-history-orange-800">
                                                        <svg
                                                            className="w-9 h-12 fill-white"
                                                            viewBox="0 0 9 13"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path d="M5.03906 12.2188C6.25781 10.6953 9 7.0625 9 5C9 2.51562 6.98438 0.5 4.5 0.5C2.01562 0.5 0 2.51562 0 5C0 7.0625 2.74219 10.6953 3.9375 12.2188C4.21875 12.5703 4.75781 12.5703 5.03906 12.2188ZM4.5 6.5C3.65625 6.5 3 5.84375 3 5C3 4.17969 3.65625 3.5 4.5 3.5C5.32031 3.5 6 4.17969 6 5C6 5.84375 5.32031 6.5 4.5 6.5Z" />
                                                        </svg>
                                                    </div>
                                                    <p className="text-14 font-700">Cart Error</p>
                                                </div>
                                            </div>

                                            <div className="flex-1 flex flex-col items-center justify-center">
                                                <svg
                                                    className="w-84 h-84"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 640 512"
                                                >
                                                    <path d="M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c29.1-57 88.4-96 156.8-96c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" />
                                                </svg>
                                                <p className="text-14 mt-6 text-darwin-neutral-700">
                                                    Unable to build cart
                                                </p>
                                                <button
                                                    className="btn--small primary-btn px-16 py-8 mt-12"
                                                    onClick={() => {
                                                        this.setState({
                                                            showAddAddress: true,
                                                            isEditingAddress: true,
                                                        });
                                                        track('BOOK_LAB_TEST_EDIT_ADDRESS_BUTTON');
                                                    }}
                                                >
                                                    Edit Address
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <Fragment>
                                            <div className="flex flex-col space-y-8 h-full col-span-3 overflow-hidden">
                                                {showSearchInput &&
                                                    canUpdateTest &&
                                                    prescriptionLabTests.length > 0 && (
                                                        <div className="flex space-x-8 overflow-auto whitespace-nowrap">
                                                            {prescriptionLabTests.map((i) => (
                                                                <div className="flex items-center space-x-12 border border-darwin-accent-bright-blue-800 bg-darwin-accent-bright-blue-100 rounded-8 px-12 py-8">
                                                                    <p className="text-13 font-700 text-darwin-accent-bright-blue-800">
                                                                        {i.name}
                                                                    </p>
                                                                    <p
                                                                        className="cursor-pointer"
                                                                        onClick={() =>
                                                                            removeLabTestHandler(
                                                                                i.id,
                                                                            )
                                                                        }
                                                                    >
                                                                        <svg
                                                                            className="w-12 h-12"
                                                                            viewBox="0 0 12 12"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path
                                                                                d="M10.7812 2.28125L7.03125 6.03125L10.75 9.75C11.0625 10.0312 11.0625 10.5 10.75 10.7812C10.4688 11.0938 10 11.0938 9.71875 10.7812L5.96875 7.0625L2.25 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 2 0.90625 1.53125 1.21875 1.21875C1.5 0.9375 1.96875 0.9375 2.28125 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.7812 1.25C11.0625 1.53125 11.0625 2 10.7812 2.28125Z"
                                                                                fill="#1A1A1A"
                                                                            />
                                                                        </svg>
                                                                    </p>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                {labOptions.length > 0 ? (
                                                    <div
                                                        className="flex flex-col flex-1 overflow-hidden"
                                                        id="options-available"
                                                    >
                                                        <div
                                                            className={`rounded-t-8 bg-white px-16 py-8 flex items-center justify-between ${
                                                                !isForEditOrder ? 'border-b' : ''
                                                            } border-darwin-neutral-100`}
                                                        >
                                                            <div className="flex items-center space-x-8">
                                                                <div className="flex items-center justify-center w-24 h-24 rounded-4 bg-darwin-accent-green-900">
                                                                    <svg
                                                                        className="w-14 h-12 fill-white"
                                                                        viewBox="0 0 512 512"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path d="M504.1 183l-176-176C324.3 2.344 318.1 0 312 0s-12.28 2.344-16.97 7.031c-9.375 9.375-9.375 24.56 0 33.94l15.16 15.16l-277.3 276.5c-38.75 38.75-45.13 102-9.375 143.5C44.08 500 72.76 512 101.5 512h.4473c26.38 0 52.75-9.1 72.88-30.12l281-280.1l15.19 15.19C475.7 221.7 481.8 224 488 224s12.28-2.344 16.97-7.031C514.3 207.6 514.3 192.4 504.1 183zM333.4 256H177.7l166.3-165.9l77.82 77.73L333.4 256z"></path>
                                                                    </svg>
                                                                </div>

                                                                <p className="text-14 font-700">
                                                                    Available Options (
                                                                    {labOptions.length})
                                                                </p>
                                                            </div>

                                                            {!isForEditOrder && !isForQuickCart && (
                                                                <div className="flex items-center space-x-5 text-13">
                                                                    <p className="text-darwin-neutral-800">
                                                                        Options are based on
                                                                    </p>
                                                                    <button
                                                                        className="flex items-center space-x-6 px-8 py-2 border border-darwin-primary-500 text-darwin-primary-500 font-700 rounded-4 disabled:opacity-70 disabled:cursor-not-allowed"
                                                                        onClick={
                                                                            editLabTestModalHandler
                                                                        }
                                                                        disabled={isForTrialOrder}
                                                                    >
                                                                        <span>
                                                                            <svg
                                                                                className="w-14 h-13 fill-darwin-primary-500"
                                                                                viewBox="0 0 14 13"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <path d="M1.84375 8.96094C1.9375 8.63281 2.125 8.32812 2.35938 8.09375L9.48438 0.96875C10.0703 0.382812 11.0312 0.382812 11.6172 0.96875L12.5312 1.88281C12.6016 1.95312 12.6719 2.04688 12.7188 2.11719C13.1172 2.70312 13.0469 3.5 12.5312 4.01562L5.40625 11.1406C5.38281 11.1641 5.33594 11.1875 5.3125 11.2344C5.07812 11.4219 4.82031 11.5625 4.53906 11.6562L1.70312 12.4766C1.51562 12.5469 1.30469 12.5 1.16406 12.3359C1 12.1953 0.953125 11.9844 1 11.7969L1.84375 8.96094ZM2.38281 11.1172L4.21094 10.5781C4.25781 10.5547 4.32812 10.5312 4.375 10.5078L3.53125 10.3438C3.34375 10.2969 3.17969 10.1562 3.15625 9.96875L2.99219 9.125C2.96875 9.17188 2.94531 9.24219 2.92188 9.28906L2.38281 11.1172ZM5.21875 9.73438L9.97656 4.97656L8.5 3.52344L3.76562 8.28125L4 9.47656L5.21875 9.73438Z" />
                                                                            </svg>
                                                                        </span>

                                                                        <span>
                                                                            Prescribed Lab Tests (
                                                                            {
                                                                                prescriptionLabTests.length
                                                                            }
                                                                            )
                                                                        </span>
                                                                    </button>
                                                                </div>
                                                            )}

                                                            {isForEditOrder && (
                                                                <div className="flex items-center space-x-6">
                                                                    <p>
                                                                        <svg
                                                                            className="w-16 h-14"
                                                                            viewBox="0 0 15 14"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path
                                                                                d="M7.5 13.125C5.16406 13.125 3.03125 11.9062 1.86328 9.875C0.695312 7.86914 0.695312 5.40625 1.86328 3.375C3.03125 1.36914 5.16406 0.125 7.5 0.125C9.81055 0.125 11.9434 1.36914 13.1113 3.375C14.2793 5.40625 14.2793 7.86914 13.1113 9.875C11.9434 11.9062 9.81055 13.125 7.5 13.125ZM6.48438 8.65625C6.12891 8.65625 5.875 8.93555 5.875 9.26562C5.875 9.62109 6.12891 9.875 6.48438 9.875H8.51562C8.8457 9.875 9.125 9.62109 9.125 9.26562C9.125 8.93555 8.8457 8.65625 8.51562 8.65625H8.3125V6.42188C8.3125 6.0918 8.0332 5.8125 7.70312 5.8125H6.48438C6.12891 5.8125 5.875 6.0918 5.875 6.42188C5.875 6.77734 6.12891 7.03125 6.48438 7.03125H7.09375V8.65625H6.48438ZM7.5 3.375C7.04297 3.375 6.6875 3.75586 6.6875 4.1875C6.6875 4.64453 7.04297 5 7.5 5C7.93164 5 8.3125 4.64453 8.3125 4.1875C8.3125 3.75586 7.93164 3.375 7.5 3.375Z"
                                                                                fill="#8E6807"
                                                                            />
                                                                        </svg>
                                                                    </p>
                                                                    <p style={{ color: '#616A8F' }}>
                                                                        Option selected below will
                                                                        replace the Current order
                                                                    </p>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {!isForEditOrder && (
                                                            <AllVendorsContainer
                                                                labOptions={labOptions}
                                                                preferredLabPartnerId={
                                                                    preferredLabPartnerId
                                                                }
                                                                preferredLabPartnerIdHandler={
                                                                    preferredLabPartnerIdHandler
                                                                }
                                                            />
                                                        )}

                                                        <div className="flex-1 overflow-scroll border-t border-darwin-neutral-100">
                                                            {labOptions.map((i, index) => (
                                                                <div
                                                                    className={`bg-white px-16 pt-16 ${
                                                                        labOptions.length ===
                                                                        index + 1
                                                                            ? 'pb-16 rounded-b-8'
                                                                            : ''
                                                                    }`}
                                                                    id={i.vendor_id}
                                                                >
                                                                    <div
                                                                        className={`relative p-16 pb-10 border ${
                                                                            selectedOption === index
                                                                                ? 'border-darwin-accent-green-800 bg-darwin-accent-green-100'
                                                                                : 'border-darwin-neutral-100'
                                                                        } rounded-8 cursor-pointer`}
                                                                        onClick={() =>
                                                                            onOptionClick(i, index)
                                                                        }
                                                                    >
                                                                        <div className="flex items-start space-x-36 min-h-68">
                                                                            <div className="flex-1 space-y-6">
                                                                                <p className="w-full text-16 font-700">
                                                                                    Option{' '}
                                                                                    {index + 1}
                                                                                </p>
                                                                                <div className="space-y-3 text-darwin-neutral-800 font-700 text-13 w-full">
                                                                                    {i.sku.map(
                                                                                        (
                                                                                            i,
                                                                                            index,
                                                                                        ) => (
                                                                                            <p className="space-x-5">
                                                                                                <span>
                                                                                                    {index +
                                                                                                        1}

                                                                                                    .
                                                                                                </span>
                                                                                                <span>
                                                                                                    {
                                                                                                        i.name
                                                                                                    }
                                                                                                </span>
                                                                                                <span>
                                                                                                    :
                                                                                                </span>
                                                                                                <span
                                                                                                    className={`relative font-400 ${
                                                                                                        i
                                                                                                            .tests
                                                                                                            ?.length
                                                                                                            ? 'pr-22'
                                                                                                            : ''
                                                                                                    } whitespace-nowrap`}
                                                                                                >
                                                                                                    ₹{' '}
                                                                                                    {
                                                                                                        i.price
                                                                                                    }
                                                                                                    {additionalMembers.length >
                                                                                                    0
                                                                                                        ? ` x ${
                                                                                                              additionalMembers.length +
                                                                                                              1
                                                                                                          }`
                                                                                                        : ''}
                                                                                                    <LabTestsIncludedInPackage
                                                                                                        tests={
                                                                                                            i.tests
                                                                                                        }
                                                                                                    />
                                                                                                </span>
                                                                                                <TestingType
                                                                                                    i={
                                                                                                        {
                                                                                                            testing_type:
                                                                                                                i.testing_type,
                                                                                                        } as LabTest
                                                                                                    }
                                                                                                    className="px-6 py-3 relative -top-1 text-11"
                                                                                                />
                                                                                            </p>
                                                                                        ),
                                                                                    )}
                                                                                    <HomeCollectionFees
                                                                                        i={i}
                                                                                        collectionType={
                                                                                            collectionType
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            <div
                                                                                className={`flex flex-col items-end space-y-6 pr-4 ${
                                                                                    i.isForSmartPackages
                                                                                        ? 'pt-16'
                                                                                        : ''
                                                                                }`}
                                                                            >
                                                                                <p className="font-700 text-18">
                                                                                    ₹{' '}
                                                                                    {i.finalprice.toFixed(
                                                                                        2,
                                                                                    )}
                                                                                </p>

                                                                                {i.finalprice !==
                                                                                    i.mrp && (
                                                                                    <p className="text-darwin-neutral-800 line-through">
                                                                                        ₹{' '}
                                                                                        {i.mrp.toFixed(
                                                                                            2,
                                                                                        )}
                                                                                    </p>
                                                                                )}

                                                                                {i.isForSmartPackages && (
                                                                                    <p
                                                                                        className="absolute -top-6 right-0 bg-darwin-accent-bright-blue-800 text-white px-10 py-6 text-10 font-700 uppercase"
                                                                                        style={{
                                                                                            borderRadius:
                                                                                                '0px 7px',
                                                                                        }}
                                                                                    >
                                                                                        Package
                                                                                    </p>
                                                                                )}
                                                                            </div>
                                                                        </div>

                                                                        <UnavailableLabTests
                                                                            unavailableLabTests={
                                                                                i.unavailableLabTests
                                                                            }
                                                                        />

                                                                        <div className="flex justify-between items-center">
                                                                            <div className="flex items-center space-x-10">
                                                                                <p className="font-700">
                                                                                    Provided by:
                                                                                </p>
                                                                                <img
                                                                                    src={getVendorLogo(
                                                                                        i.vendor_id,
                                                                                    )}
                                                                                    alt={i.vendor}
                                                                                    className="h-28 min-w-64"
                                                                                />
                                                                                <PreferredLabPartner
                                                                                    option={i}
                                                                                    preferredLabPartnerId={
                                                                                        preferredLabPartnerId
                                                                                    }
                                                                                    preferredLabPartnerIdHandler={
                                                                                        preferredLabPartnerIdHandler
                                                                                    }
                                                                                />
                                                                            </div>

                                                                            <p
                                                                                className={`flex space-x-8 font-700 border border-darwin-primary-500 py-8 px-16 rounded-4 ${
                                                                                    selectedOption ===
                                                                                    index
                                                                                        ? 'bg-actionPrimary text-white'
                                                                                        : 'text-darwin-primary-500'
                                                                                }`}
                                                                            >
                                                                                {selectedOption ===
                                                                                index ? (
                                                                                    <Fragment>
                                                                                        <span>
                                                                                            ✓
                                                                                        </span>
                                                                                        <span>
                                                                                            Selected
                                                                                        </span>
                                                                                    </Fragment>
                                                                                ) : (
                                                                                    'Select Package'
                                                                                )}
                                                                            </p>
                                                                        </div>

                                                                        {i.vendor_id?.toLowerCase() ===
                                                                            ORANGE_HEALTH_VENDOR_ID && (
                                                                            <div className="flex space-x-5 items-center justify-end font-700 pt-5">
                                                                                <p>
                                                                                    Pickup : 2 Hours
                                                                                </p>
                                                                                <p className="text-16">
                                                                                    |
                                                                                </p>
                                                                                <p>
                                                                                    Delivery : 6
                                                                                    Hours
                                                                                </p>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                            {!canUpdateTest && (
                                                                <div className="mt-16">
                                                                    <InfoText />
                                                                </div>
                                                            )}
                                                            <div className="h-144"></div>
                                                        </div>
                                                    </div>
                                                ) : showSearchInput ? (
                                                    <div className="flex flex-col items-center space-y-12 flex-1 overflow-hidden pt-10">
                                                        <p>
                                                            <svg
                                                                className="w-12 h-8 fill-darwin-neutrals-600"
                                                                viewBox="0 0 12 8"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M6.6875 1.3125L10.6875 5.3125C10.9688 5.59375 11.0625 6.03125 10.9062 6.40625C10.75 6.78125 10.375 7.03125 10 7.03125H2C1.59375 7.03125 1.21875 6.78125 1.0625 6.40625C0.90625 6.03125 1 5.59375 1.28125 5.3125L5.28125 1.3125C5.65625 0.90625 6.3125 0.90625 6.6875 1.3125Z" />
                                                            </svg>
                                                        </p>
                                                        <p className="text-13 text-darwin-neutrals-600">
                                                            Search for lab investigation to add to
                                                            cart
                                                        </p>
                                                        {prescriptionLabTests.length === 0 && (
                                                            <Fragment>
                                                                <p className="text-13 text-darwin-neutrals-600">
                                                                    Or
                                                                </p>
                                                                <button
                                                                    className="flex items-center space-x-8 px-12 py-8 rounded-8 text-white bg-darwin-accent-bright-blue-800 font-700 text-13 disabled:opacity-70 disabled:cursor-not-allowed"
                                                                    onClick={onAddFromLastRx}
                                                                    disabled={
                                                                        isFetchingLastRx ||
                                                                        !lastRxLabTests ||
                                                                        lastRxLabTests.length === 0
                                                                    }
                                                                >
                                                                    {isFetchingLastRx ? (
                                                                        <svg
                                                                            className="w-16 h-16 fill-white animate-spin"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 512 512"
                                                                        >
                                                                            <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                                                        </svg>
                                                                    ) : lastRxLabTests &&
                                                                      lastRxLabTests.length > 0 ? (
                                                                        <svg
                                                                            className="w-16 h-16 fill-white"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 448 512"
                                                                        >
                                                                            <path d="M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"></path>
                                                                        </svg>
                                                                    ) : null}
                                                                    <p>
                                                                        {isFetchingLastRx ||
                                                                        (lastRxLabTests &&
                                                                            lastRxLabTests.length >
                                                                                0)
                                                                            ? 'Add from last Rx'
                                                                            : 'No Past Visits Found'}
                                                                    </p>
                                                                </button>
                                                            </Fragment>
                                                        )}
                                                    </div>
                                                ) : null}
                                            </div>

                                            <div className="h-full col-span-2 space-y-12 overflow-scroll hide-scrollbar pb-144">
                                                {MAX_DISCOUNT !== 0 && (
                                                    <div
                                                        className="bg-white rounded-8 pb-16"
                                                        id="apply-discount"
                                                    >
                                                        <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                                                            <div className="flex items-center space-x-8">
                                                                <div className="flex items-center justify-center w-24 h-24 rounded-4 bg-darwin-accent-burgandy-800">
                                                                    <svg
                                                                        className="w-11 h-12 fill-white"
                                                                        viewBox="0 0 11 11"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path d="M0.25 1.375V4.89062C0.25 5.28906 0.390625 5.66406 0.671875 5.94531L4.79688 10.0703C5.38281 10.6562 6.34375 10.6562 6.92969 10.0703L10.0469 6.95312C10.6328 6.36719 10.6328 5.40625 10.0469 4.82031L5.92188 0.695312C5.64062 0.414062 5.26562 0.273438 4.86719 0.273438H1.375C0.742188 0.25 0.25 0.765625 0.25 1.375ZM2.875 3.625C2.45312 3.625 2.125 3.29688 2.125 2.875C2.125 2.47656 2.45312 2.125 2.875 2.125C3.27344 2.125 3.625 2.47656 3.625 2.875C3.625 3.29688 3.27344 3.625 2.875 3.625Z" />
                                                                    </svg>
                                                                </div>
                                                                <p className="text-14 font-700">
                                                                    Discount
                                                                </p>
                                                            </div>
                                                        </div>

                                                        {canUpdateDiscount ? (
                                                            <div className="space-y-12 p-16 pb-0">
                                                                <p className="text-14">
                                                                    Enter discount percentage
                                                                </p>

                                                                <div className="flex items-center space-x-8 text-14">
                                                                    <div className="p-10 border border-darwin-neutral-200 rounded-8 flex items-center space-x-8">
                                                                        <input
                                                                            type="number"
                                                                            placeholder="000"
                                                                            className="w-64"
                                                                            value={discountInp}
                                                                            onChange={(e) =>
                                                                                this.setState({
                                                                                    discountInp:
                                                                                        e.target
                                                                                            .value,
                                                                                })
                                                                            }
                                                                        />
                                                                        <svg
                                                                            className="w-12 h-12 fill-darwin-neutral-700"
                                                                            viewBox="0 0 12 11"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path d="M11.0312 0.71875C10.7578 0.445312 10.3477 0.445312 10.1016 0.71875L0.914062 9.90625C0.640625 10.1523 0.640625 10.5625 0.914062 10.8086C1.05078 10.9453 1.21484 11 1.40625 11C1.57031 11 1.73438 10.9453 1.84375 10.8086L11.0312 1.62109C11.3047 1.375 11.3047 0.964844 11.0312 0.71875ZM2.5 3.5625C3.21094 3.5625 3.8125 2.98828 3.8125 2.25C3.8125 1.53906 3.21094 0.9375 2.5 0.9375C1.76172 0.9375 1.1875 1.53906 1.1875 2.25C1.1875 2.98828 1.76172 3.5625 2.5 3.5625ZM9.5 7.9375C8.76172 7.9375 8.1875 8.53906 8.1875 9.25C8.1875 9.98828 8.76172 10.5625 9.5 10.5625C10.2109 10.5625 10.8125 9.98828 10.8125 9.25C10.8125 8.53906 10.2109 7.9375 9.5 7.9375Z" />
                                                                        </svg>
                                                                    </div>
                                                                    <button
                                                                        className="space-x-8 p-10 px-16 bg-darwin-primary-500 rounded-8 text-white font-700"
                                                                        onClick={applyDiscount}
                                                                    >
                                                                        {discountInp === discount &&
                                                                        Number(discount) ? (
                                                                            <Fragment>
                                                                                <span>✓</span>
                                                                                <span>Applied</span>
                                                                            </Fragment>
                                                                        ) : (
                                                                            'Apply'
                                                                        )}
                                                                    </button>
                                                                </div>

                                                                <p className="text-darwin-neutral-600">
                                                                    {MAX_DISCOUNT}% maximum discount
                                                                    applicable
                                                                </p>
                                                            </div>
                                                        ) : (
                                                            <div className="space-y-12 p-16 pb-0">
                                                                <p className="text-darwin-neutral-600 font-700">
                                                                    {discount}% discount applied ✓
                                                                </p>
                                                                <InfoText />
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                <div className="bg-white rounded-8 pb-16">
                                                    <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                                                        <div className="flex items-center space-x-8">
                                                            <div className="flex items-center justify-center w-24 h-24 rounded-4 bg-darwin-primary-500">
                                                                <svg
                                                                    className="w-8 h-12 fill-white"
                                                                    viewBox="0 0 8 11"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path d="M0.25 1C0.25 0.601562 0.578125 0.25 1 0.25H2.5H2.875H7C7.39844 0.25 7.75 0.601562 7.75 1C7.75 1.42188 7.39844 1.75 7 1.75H5.66406C5.89844 2.10156 6.0625 2.47656 6.15625 2.875H7C7.39844 2.875 7.75 3.22656 7.75 3.625C7.75 4.04688 7.39844 4.375 7 4.375H6.15625C5.85156 5.75781 4.70312 6.8125 3.29688 6.97656L6.67188 9.39062C7.02344 9.64844 7.09375 10.1172 6.85938 10.4453C6.60156 10.7734 6.13281 10.8672 5.80469 10.6094L0.554688 6.85938C0.296875 6.67188 0.179688 6.34375 0.273438 6.03906C0.367188 5.71094 0.671875 5.5 1 5.5H2.875C3.625 5.5 4.30469 5.05469 4.58594 4.375H1C0.578125 4.375 0.25 4.04688 0.25 3.625C0.25 3.22656 0.578125 2.875 1 2.875H4.58594C4.30469 2.21875 3.625 1.75 2.875 1.75H2.5H1C0.578125 1.75 0.25 1.42188 0.25 1Z" />
                                                                </svg>
                                                            </div>
                                                            <p className="text-14 font-700">
                                                                Amount to be Paid
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {labOptions.length === 0 && showSearchInput ? (
                                                        <div className="flex flex-col items-center space-y-12 px-16 pt-24 pb-16">
                                                            <svg
                                                                className="w-26 h-26 fill-darwin-neutrals-600"
                                                                viewBox="0 0 25 25"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M15.4219 1.32812L16.9219 2.82812L22.125 8.07812L23.625 9.57812C24.0938 10.0469 24.0938 10.75 23.625 11.1719C23.2031 11.6406 22.5 11.6406 22.0781 11.1719L21.375 10.4688L8.25 23.5938C7.3125 24.5312 6.09375 25 4.82812 25C2.15625 25 0 22.8438 0 20.1719C0 18.9062 0.46875 17.6875 1.40625 16.75L14.5312 3.625L13.8281 2.92188C13.3594 2.5 13.3594 1.79688 13.8281 1.32812C14.25 0.90625 14.9531 0.90625 15.4219 1.32812ZM8.34375 13H8.29688H15.6562L19.7812 8.875L16.125 5.21875L8.34375 13Z" />
                                                            </svg>
                                                            <p className="text-13 text-darwin-neutrals-600">
                                                                Add lab investigations to your cart
                                                                to place the order
                                                            </p>
                                                        </div>
                                                    ) : (
                                                        <div className="space-y-16 p-16 pb-0 ">
                                                            <div className="text-14 space-y-8">
                                                                <div className="flex items-center justify-between">
                                                                    <p>Total MRP</p>
                                                                    <p>
                                                                        ₹{' '}
                                                                        {labOptions[
                                                                            selectedOption
                                                                        ].mrp.toFixed(2)}
                                                                    </p>
                                                                </div>
                                                                {MAX_DISCOUNT !== 0 && (
                                                                    <div className="flex items-center justify-between">
                                                                        <p>Discount</p>
                                                                        <p className="text-darwin-accent-green-900">
                                                                            - {discount || 0}%
                                                                        </p>
                                                                    </div>
                                                                )}
                                                                {MAX_DISCOUNT !== 0 && (
                                                                    <div className="flex items-center justify-between">
                                                                        <p>Discounted Price</p>
                                                                        <p>
                                                                            ₹{' '}
                                                                            {discountedPrice.toFixed(
                                                                                2,
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                )}
                                                                {!hideExtraCharges(
                                                                    labOptions[selectedOption],
                                                                ) &&
                                                                    Object.entries(
                                                                        labOptions[selectedOption]
                                                                            .extra_charges,
                                                                    )?.map((i) => (
                                                                        <div className="flex items-center justify-between">
                                                                            <p className="capitalize">
                                                                                {i[0]?.replaceAll?.(
                                                                                    '_',
                                                                                    ' ',
                                                                                )}
                                                                            </p>
                                                                            <p>
                                                                                ₹ {i[1]?.toFixed(2)}
                                                                            </p>
                                                                        </div>
                                                                    ))}
                                                            </div>
                                                            <div className="h-1 bg-darwin-neutral-100"></div>
                                                            <div className="flex items-center justify-between text-18 font-700">
                                                                <p>Total Amount</p>
                                                                <p>
                                                                    ₹{' '}
                                                                    {(
                                                                        labOptions[selectedOption]
                                                                            .finalprice +
                                                                        calculateExtraCharges(
                                                                            labOptions[
                                                                                selectedOption
                                                                            ],
                                                                        )
                                                                    ).toFixed(2)}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                {!isInclinicCollectionSelected && (
                                                    <Fragment>
                                                        <div
                                                            className="bg-white rounded-8"
                                                            id="add-address"
                                                        >
                                                            <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                                                                <div className="flex items-center space-x-8">
                                                                    <div className="flex items-center justify-center w-24 h-24 rounded-4 bg-darwin-accent-medical-history-orange-800">
                                                                        <svg
                                                                            className="w-9 h-12 fill-white"
                                                                            viewBox="0 0 9 13"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path d="M5.03906 12.2188C6.25781 10.6953 9 7.0625 9 5C9 2.51562 6.98438 0.5 4.5 0.5C2.01562 0.5 0 2.51562 0 5C0 7.0625 2.74219 10.6953 3.9375 12.2188C4.21875 12.5703 4.75781 12.5703 5.03906 12.2188ZM4.5 6.5C3.65625 6.5 3 5.84375 3 5C3 4.17969 3.65625 3.5 4.5 3.5C5.32031 3.5 6 4.17969 6 5C6 5.84375 5.32031 6.5 4.5 6.5Z" />
                                                                        </svg>
                                                                    </div>
                                                                    <p className="text-14 font-700">
                                                                        Patient Address
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            <div>
                                                                {isValidAddress() ? (
                                                                    <div className="p-16">
                                                                        <div className="border-b border-darwin-neutral-100 pb-10 mb-10 text-14 flex items-start space-x-12">
                                                                            <div className="flex-1">
                                                                                {[
                                                                                    line,
                                                                                    landmark,
                                                                                    city,
                                                                                    state,
                                                                                    pincode,
                                                                                ].join(', ')}
                                                                                .
                                                                            </div>
                                                                            {canUpdateAddress && (
                                                                                <svg
                                                                                    className="w-14 h-13 fill-darwin-neutral-900 mt-3 cursor-pointer"
                                                                                    viewBox="0 0 14 13"
                                                                                    fill="none"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    onClick={
                                                                                        editAddressHandler
                                                                                    }
                                                                                >
                                                                                    <path d="M1.84375 8.96094C1.9375 8.63281 2.125 8.32812 2.35938 8.09375L9.48438 0.96875C10.0703 0.382812 11.0312 0.382812 11.6172 0.96875L12.5312 1.88281C12.6016 1.95312 12.6719 2.04688 12.7188 2.11719C13.1172 2.70312 13.0469 3.5 12.5312 4.01562L5.40625 11.1406C5.38281 11.1641 5.33594 11.1875 5.3125 11.2344C5.07812 11.4219 4.82031 11.5625 4.53906 11.6562L1.70312 12.4766C1.51562 12.5469 1.30469 12.5 1.16406 12.3359C1 12.1953 0.953125 11.9844 1 11.7969L1.84375 8.96094ZM2.38281 11.1172L4.21094 10.5781C4.25781 10.5547 4.32812 10.5312 4.375 10.5078L3.53125 10.3438C3.34375 10.2969 3.17969 10.1562 3.15625 9.96875L2.99219 9.125C2.96875 9.17188 2.94531 9.24219 2.92188 9.28906L2.38281 11.1172ZM5.21875 9.73438L9.97656 4.97656L8.5 3.52344L3.76562 8.28125L4 9.47656L5.21875 9.73438Z" />
                                                                                </svg>
                                                                            )}
                                                                        </div>

                                                                        {canUpdateAddress ? (
                                                                            <div className="font-700 text-darwin-primary-500">
                                                                                {patientAddressArray.length >
                                                                                1 ? (
                                                                                    <div
                                                                                        className="flex items-center space-x-8 cursor-pointer"
                                                                                        onClick={() => {
                                                                                            this.setState(
                                                                                                {
                                                                                                    showAddAddress: true,
                                                                                                    showOptions: true,
                                                                                                },
                                                                                            );
                                                                                            track(
                                                                                                'BOOK_LAB_TEST_MORE_ADDRESS_OPTION',
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        <p>
                                                                                            {patientAddressArray.length -
                                                                                                1}{' '}
                                                                                            more
                                                                                        </p>
                                                                                        <svg
                                                                                            className="w-9 h-12 fill-darwin-primary-500"
                                                                                            viewBox="0 0 7 11"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                        >
                                                                                            <path d="M6.01562 4.98438C6.32031 5.26562 6.32031 5.75781 6.01562 6.03906L1.51562 10.5391C1.23438 10.8438 0.742188 10.8438 0.460938 10.5391C0.15625 10.2578 0.15625 9.76562 0.460938 9.48438L4.42188 5.5L0.460938 1.53906C0.15625 1.25781 0.15625 0.765625 0.460938 0.484375C0.742188 0.179688 1.23438 0.179688 1.51562 0.484375L6.01562 4.98438Z" />
                                                                                        </svg>
                                                                                    </div>
                                                                                ) : (
                                                                                    <div
                                                                                        className="flex items-center space-x-8 cursor-pointer"
                                                                                        onClick={() => {
                                                                                            this.setState(
                                                                                                {
                                                                                                    showAddAddress: true,
                                                                                                },
                                                                                            );
                                                                                            track(
                                                                                                'BOOK_LAB_TEST_NEW_ADDRESS',
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        <svg
                                                                                            className="w-12 h-12 fill-darwin-primary-500"
                                                                                            viewBox="0 0 11 11"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                        >
                                                                                            <path d="M6.25 1.375C6.25 0.976562 5.89844 0.625 5.5 0.625C5.07812 0.625 4.75 0.976562 4.75 1.375V4.75H1.375C0.953125 4.75 0.625 5.10156 0.625 5.5C0.625 5.92188 0.953125 6.25 1.375 6.25H4.75V9.625C4.75 10.0469 5.07812 10.375 5.5 10.375C5.89844 10.375 6.25 10.0469 6.25 9.625V6.25H9.625C10.0234 6.25 10.375 5.92188 10.375 5.5C10.375 5.10156 10.0234 4.75 9.625 4.75H6.25V1.375Z" />
                                                                                        </svg>
                                                                                        <p>
                                                                                            Add new
                                                                                            address
                                                                                        </p>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            <InfoText />
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <div className="px-16 grid place-items-center pb-16">
                                                                        <DeliveryAddressMapSVG />
                                                                        <button
                                                                            className="btn--small primary-btn px-16 py-8"
                                                                            onClick={() => {
                                                                                this.setState({
                                                                                    showAddAddress: true,
                                                                                    isEditingAddress: true,
                                                                                });
                                                                                track(
                                                                                    'BOOK_LAB_TEST_ADDRESS_BUTTON',
                                                                                );
                                                                            }}
                                                                        >
                                                                            Add Address
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="bg-white rounded-8">
                                                            <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                                                                <div className="flex items-center space-x-8">
                                                                    <div className="flex items-center justify-center w-24 h-24 rounded-4 bg-darwin-accent-bright-yellow-800">
                                                                        <svg
                                                                            className="w-13 h-13 fill-white"
                                                                            viewBox="0 0 13 13"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path d="M3.84375 1.08594C3.67969 0.640625 3.1875 0.429688 2.74219 0.546875L0.679688 1.10938C0.28125 1.22656 0 1.57812 0 2C0 7.8125 4.6875 12.5 10.5 12.5C10.9219 12.5 11.2734 12.2188 11.3906 11.8203L11.9531 9.75781C12.0703 9.3125 11.8594 8.82031 11.4141 8.65625L9.16406 7.71875C8.78906 7.55469 8.34375 7.64844 8.08594 7.97656L7.125 9.125C5.48438 8.35156 4.14844 7.01562 3.375 5.375L4.52344 4.41406C4.85156 4.15625 4.94531 3.71094 4.78125 3.33594L3.84375 1.08594Z" />
                                                                        </svg>
                                                                    </div>
                                                                    <p className="text-14 font-700">
                                                                        Recipient Contact
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            <div className="flex items-start p-16 space-x-12">
                                                                <div className="flex-1 space-y-4">
                                                                    <p className="font-700">
                                                                        {recipientName}
                                                                    </p>
                                                                    <p className="flex flex-wrap gap-x-8">
                                                                        <p>+91 {mobile}</p>
                                                                        {alternative_mobile.length !==
                                                                            0 && (
                                                                            <p>
                                                                                (Alt: +91{' '}
                                                                                {alternative_mobile}
                                                                                )
                                                                            </p>
                                                                        )}
                                                                    </p>
                                                                    {!canUpdatePatientDetails && (
                                                                        <InfoText />
                                                                    )}
                                                                </div>
                                                                {canUpdatePatientDetails && (
                                                                    <svg
                                                                        className="w-14 h-13 fill-darwin-neutral-900 mt-3 cursor-pointer"
                                                                        viewBox="0 0 14 13"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        onClick={
                                                                            showAddRecipientModalHandler
                                                                        }
                                                                    >
                                                                        <path d="M1.84375 8.96094C1.9375 8.63281 2.125 8.32812 2.35938 8.09375L9.48438 0.96875C10.0703 0.382812 11.0312 0.382812 11.6172 0.96875L12.5312 1.88281C12.6016 1.95312 12.6719 2.04688 12.7188 2.11719C13.1172 2.70312 13.0469 3.5 12.5312 4.01562L5.40625 11.1406C5.38281 11.1641 5.33594 11.1875 5.3125 11.2344C5.07812 11.4219 4.82031 11.5625 4.53906 11.6562L1.70312 12.4766C1.51562 12.5469 1.30469 12.5 1.16406 12.3359C1 12.1953 0.953125 11.9844 1 11.7969L1.84375 8.96094ZM2.38281 11.1172L4.21094 10.5781C4.25781 10.5547 4.32812 10.5312 4.375 10.5078L3.53125 10.3438C3.34375 10.2969 3.17969 10.1562 3.15625 9.96875L2.99219 9.125C2.96875 9.17188 2.94531 9.24219 2.92188 9.28906L2.38281 11.1172ZM5.21875 9.73438L9.97656 4.97656L8.5 3.52344L3.76562 8.28125L4 9.47656L5.21875 9.73438Z" />
                                                                    </svg>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </Fragment>
                                                )}

                                                <div className="bg-white rounded-8 pb-16">
                                                    <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                                                        <div className="flex items-center space-x-8">
                                                            <div className="flex items-center justify-center w-24 h-24 rounded-4 bg-darwin-accent-examination-findings-sky-blue-800">
                                                                <svg
                                                                    className="w-14 h-12 fill-white"
                                                                    viewBox="0 0 11 13"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M5.5 6.5C4.42188 6.5 3.4375 5.9375 2.89844 5C2.35938 4.08594 2.35938 2.9375 2.89844 2C3.4375 1.08594 4.42188 0.5 5.5 0.5C6.55469 0.5 7.53906 1.08594 8.07812 2C8.61719 2.9375 8.61719 4.08594 8.07812 5C7.53906 5.9375 6.55469 6.5 5.5 6.5ZM4.42188 7.625H6.55469C8.875 7.625 10.75 9.5 10.75 11.8203C10.75 12.1953 10.4219 12.5 10.0469 12.5H0.929688C0.554688 12.5 0.25 12.1953 0.25 11.8203C0.25 9.5 2.10156 7.625 4.42188 7.625Z"
                                                                        fill="white"
                                                                    />
                                                                </svg>
                                                            </div>
                                                            <p className="text-14 font-700">
                                                                Customer Details
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <AdditionalMembers
                                                        name={name}
                                                        age={age}
                                                        gender={gender}
                                                        mobile={mobile}
                                                        additionalMembers={additionalMembers}
                                                        toggleAddAdditionalMember={
                                                            toggleAddAdditionalMember
                                                        }
                                                        deleteAdditionalMember={
                                                            deleteAdditionalMember
                                                        }
                                                        hideAddMemberButton={isForEditOrder}
                                                    />
                                                </div>
                                            </div>
                                        </Fragment>
                                    )}
                                </div>

                                {selectedSlotDetails && (
                                    <div
                                        className={`font-700 text-darwin-neutral-800 flex items-center justify-center space-x-4 p-10 absolute right-16 bottom-80 border rounded-8 border border-darwin-accent-green-800 bg-darwin-accent-green-100 ${
                                            canUpdateSlot ? 'cursor-pointer' : 'cursor-not-allowed'
                                        }`}
                                        onClick={
                                            canUpdateSlot ? showSelectSlotModalHandler : undefined
                                        }
                                    >
                                        <p className="text-darwin-neutral-1000">Slot Details:</p>
                                        <p>{slotDetails['start_time']}</p>
                                        <p>-</p>
                                        <p>{slotDetails['end_time']}</p>
                                        <p>({showDateInText(slotDetails['date'])})</p>
                                    </div>
                                )}

                                {labOptions.length !== 0 && createCartErrorCode && (
                                    <p
                                        className="font-700 p-10 absolute right-16 bottom-80 border rounded-8 border border-darwin-status-warning-500 bg-darwin-status-warning-100 text-darwin-status-warning-500 cursor-pointer"
                                        onClick={
                                            createCartErrorCode === ERR_NON_SERVICEABLE
                                                ? editAddressHandler
                                                : editLabTestModalHandler
                                        }
                                    >
                                        {createCartErrorObj[createCartErrorCode] ||
                                            createCartErrorCode}
                                    </p>
                                )}
                            </div>

                            <div className="absolute left-16 right-16 bottom-16 flex items-center justify-between p-8 bg-actionPrimary rounded-8 space-x-16">
                                <button
                                    className="text-white text-14 font-700 ml-10 py-5"
                                    onClick={isForTrialOrder ? exitTrialToggleHandler : closeMe}
                                >
                                    Cancel
                                </button>
                                <div className="flex items-center justify-end flex-wrap gap-10">
                                    {labOptions.length !== 0 ? (
                                        <Fragment>
                                            {isInclinicCollection && (
                                                <button className="px-16 py-9 btn--small secondary-btn-v2">
                                                    <p>Sample Collection : </p>
                                                    <select
                                                        className="pr-4 font-700 capitalize"
                                                        style={{ background: 'inherit' }}
                                                        value={collectionType}
                                                        onChange={collectionTypeHandler}
                                                    >
                                                        {sampleCollectionTypes.map((i) => (
                                                            <option value={i}>
                                                                {i.split('_')[0]}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </button>
                                            )}

                                            <button className="px-16 py-9 btn--small secondary-btn-v2">
                                                <p>Payment Mode : </p>
                                                <select
                                                    className="pr-4 font-700 disabled:opacity-70 disabled:cursor-not-allowed"
                                                    style={{ background: 'inherit' }}
                                                    value={paymode}
                                                    onChange={paymodeHandler}
                                                    disabled={isForTrialOrder || !canUpdatePaymode}
                                                >
                                                    {!isForTrialOrder && (
                                                        <option value="">Select Paymode</option>
                                                    )}
                                                    {paymodeArray.map((i) => (
                                                        <option
                                                            value={i[0]}
                                                            disabled={
                                                                isInclinicCollectionSelected &&
                                                                i[0] === 'COD'
                                                            }
                                                        >
                                                            {i[1]}
                                                        </option>
                                                    ))}
                                                </select>
                                            </button>

                                            {!isValidAddress() && !isInclinicCollectionSelected ? (
                                                <button
                                                    className="px-16 py-10 btn--small primary-btn-v2"
                                                    onClick={() => {
                                                        this.setState({
                                                            showAddAddress: true,
                                                            isEditingAddress: true,
                                                        });
                                                        track('BOOK_LAB_TEST_ADDRESS_BUTTON');
                                                    }}
                                                >
                                                    <svg
                                                        className="w-16 h-16 fill-darwin-primary-500"
                                                        viewBox="0 0 16 16"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M8 0C8.53125 0 9 0.46875 9 1V2.09375C11.5 2.53125 13.4688 4.5 13.9062 7H15C15.5312 7 16 7.46875 16 8C16 8.5625 15.5312 9 15 9H13.9062C13.4688 11.5312 11.5 13.5 9 13.9375V15C9 15.5625 8.53125 16 8 16C7.4375 16 7 15.5625 7 15V13.9375C4.46875 13.5 2.5 11.5312 2.0625 9H1C0.4375 9 0 8.5625 0 8C0 7.46875 0.4375 7 1 7H2.0625C2.5 4.5 4.46875 2.53125 7 2.09375V1C7 0.46875 7.4375 0 8 0ZM4 8C4 10.2188 5.78125 12 8 12C10.1875 12 12 10.2188 12 8C12 5.8125 10.1875 4 8 4C5.78125 4 4 5.8125 4 8ZM8 10.5C6.59375 10.5 5.5 9.40625 5.5 8C5.5 6.625 6.59375 5.5 8 5.5C9.375 5.5 10.5 6.625 10.5 8C10.5 9.40625 9.375 10.5 8 10.5Z" />
                                                    </svg>

                                                    <span className="text-14 font-700">
                                                        Add Address
                                                    </span>
                                                </button>
                                            ) : !selectedSlotDetails &&
                                              !isInclinicCollectionSelected ? (
                                                <button
                                                    className="px-16 py-10 btn--small primary-btn-v2"
                                                    onClick={showSelectSlotModalHandler}
                                                    disabled={Boolean(createCartErrorCode)}
                                                    id="select-slot"
                                                >
                                                    Select Slot
                                                </button>
                                            ) : (
                                                <button
                                                    className="px-16 py-10 btn--small primary-btn-v2"
                                                    onClick={bookLabTestHandler}
                                                    disabled={isBookLabTestLoading}
                                                    id="place-order"
                                                >
                                                    <div className="flex items-center justify-center w-16 h-16">
                                                        {isBookLabTestLoading ? (
                                                            <svg
                                                                className="w-16 h-16 fill-textColor-secondary animate-spin"
                                                                role="img"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 512 512"
                                                            >
                                                                <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                                            </svg>
                                                        ) : (
                                                            <svg
                                                                className="w-16 h-16 fill-actionPrimary"
                                                                role="img"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 448 512"
                                                            >
                                                                <path d="M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"></path>
                                                            </svg>
                                                        )}
                                                    </div>
                                                    <p>
                                                        Book Lab Test for ₹ {Math.ceil(finalprice)}
                                                    </p>
                                                </button>
                                            )}
                                        </Fragment>
                                    ) : null}
                                </div>
                            </div>
                        </Fragment>
                    )}
                </div>

                {finishedState && finishedState.length > 1 && (
                    <p className="absolute bottom-0 right-0 left-0 bg-white p-5 text-center text-13 text-darwin-accent-bright-yellow-900 font-700 border-t border-darwin-neutral-100">
                        This order was split into {finishedState.length} orders.
                    </p>
                )}

                {showAddAddress && (
                    <AddAddressModalCC
                        closeMe={() =>
                            this.setState({
                                showAddAddress: false,
                                isEditingAddress: false,
                                showOptions: false,
                            })
                        }
                        setAddress={setAddressHandler}
                        addFormInput={addressFormInput}
                        patientId={patientid}
                        showOptions={showOptions}
                        isEditingAddress={isEditingAddress}
                        currentOptionId={addressFormInput._id}
                        pincode={addressFormInput.pincode}
                    />
                )}

                {showSelectSlotModal && (
                    <SelectSlotModal
                        closeMe={() => {
                            this.setState({ showSelectSlotModal: false });
                        }}
                        vendor={vendor}
                        vendor_id={vendor_id}
                        selectSlotHandler={selectSlotHandler}
                        addressFormInput={addressFormInput}
                        selectedSlotDetails={selectedSlotDetails}
                    />
                )}

                {showAddRecipient && (
                    <AddRecipientModal
                        closeMe={() => this.setState({ showAddRecipient: false })}
                        setRecipient={setRecipientHandler}
                        recipientDetails={recipientDetails}
                        numberError={numberError || 'mobile'}
                    />
                )}

                {showSelectPaymode && (
                    <SelectPaymodeModal
                        closeMe={() => this.setState({ showSelectPaymode: false })}
                        paymode={paymode}
                        setPaymode={(paymode) => this.setState({ paymode })}
                        paymodeArray={paymodeArray}
                        isInclinicCollectionSelected={isInclinicCollectionSelected}
                    />
                )}

                {showEditLabTest && (
                    <EditLabTestModal
                        closeMe={() => this.setState({ showEditLabTest: false })}
                        prescriptionLabTests={prescriptionLabTests}
                        selectedLabTests={selectedLabTests}
                        onSave={editLabTestsHandler}
                    />
                )}

                {showExitTrialWarningModal && (
                    <ExitTrialWarningModal type={'lab'} onResumeTrial={exitTrialToggleHandler} />
                )}

                {isForTrialOrder && (
                    <ShepherdTour
                        steps={getSteps(changeSteps)}
                        tourOptions={{
                            defaultStepOptions: {
                                cancelIcon: {
                                    enabled: true,
                                },
                                highlightClass: 'highlight',
                                scrollTo: true,
                            },
                            exitOnEsc: true,
                        }}
                    >
                        <Button />
                    </ShepherdTour>
                )}

                {activeOrder && (
                    <CancelOrderOrBooking
                        activeTab={ACTIVE_TAB.LABS}
                        orderDetails={activeOrder}
                        onClose={() => toggleActiveOrder(undefined)}
                        onRefresh={onRefresh}
                    />
                )}

                {showAddAdditionalMemberModal && (
                    <AddPtModal
                        close={toggleAddAdditionalMember}
                        callback={onAddAdditionalMember}
                        hideABHAFlow
                        isAbhaNewFlow={false}
                        docid={docId}
                        cId={getSelectedClinicId() || ''}
                    />
                )}

                {isForEditOrder && showLabOrderEditUpdates && updateStatuses && (
                    <LabOrderEditUpdates
                        patientName={name}
                        closeMe={closeLabOrderEditUpdates}
                        updateStatuses={updateStatuses}
                        onTryAgain={onTryAgain}
                    />
                )}
            </Fragment>
        );
    }
}

export default connect((state: GlobalState) => ({
    hxngPreferredLabPartnerId: getGenieSetting(state, 'hxngPreferredLabPartnerId') as string[],
}))(BookLabTests);

export const BookLabTestsDialog: React.FC<{
    closeMe: () => void;
    formData: PatientFormData[];
    patientid: string;
    name: string;
    phone: string;
    gender: string;
    pxid: string;
    age: number;
    orderId?: string;
    showGoToHEDashboardButton?: boolean;
    isForQuickCart?: boolean;
    patient?: Patient;
    isForEditOrder?: boolean;
    onRefresh?: () => void;
}> = ({
    closeMe,
    formData,
    patientid,
    name,
    phone,
    gender,
    pxid,
    age,
    orderId,
    showGoToHEDashboardButton,
    isForQuickCart,
    patient,
    isForEditOrder,
    onRefresh,
}) => {
    const hxngPreferredLabPartnerId = useSelector(
        (state: GlobalState) => getGenieSetting(state, 'hxngPreferredLabPartnerId') as string[],
    );
    const closeMeWithRefresh = (): void => {
        closeMe();
        onRefresh && onRefresh();
    };
    return (
        <Hotkeys keyName="esc" onKeyDown={closeMeWithRefresh}>
            <SlideFromRightWrapper closeMe={closeMeWithRefresh} cssClass="w-80p select-none">
                <BookLabTests
                    closeMe={closeMeWithRefresh}
                    formData={formData}
                    patientid={patientid}
                    name={name}
                    phone={phone}
                    gender={gender}
                    pxid={pxid}
                    age={age}
                    orderId={orderId}
                    hxngPreferredLabPartnerId={hxngPreferredLabPartnerId}
                    showGoToHEDashboardButton={showGoToHEDashboardButton}
                    isForQuickCart={isForQuickCart}
                    patient={patient}
                    isForEditOrder={isForEditOrder}
                />
            </SlideFromRightWrapper>
        </Hotkeys>
    );
};
